import { Link, useLocation } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

import { logout } from "@/lib/utils";
import { useDefaultStore } from "@/stores";

export const Header = () => {
	const { decodedAccessToken } = useDefaultStore();
	const isAdmin = (decodedAccessToken?.user_level ?? 0) >= 2;
	const { pathname } = useLocation();
	const isAdminPath = pathname.startsWith("/admin");

	return (
		<header className="w-full flex justify-between items-center p-4 gap-2">
			<p className="text-sm sm:text-lg font-semibold">
				<span className="hidden sm:inline">
					{decodedAccessToken?.user_hospital_name}&nbsp;
				</span>
				{decodedAccessToken?.user_name}님 환영합니다.
			</p>

			<div className="flex items-center gap-4">
				{isAdmin && (
					<Button
						variant="outline"
						size="sm"
						className="rounded-full"
						asChild
					>
						{isAdminPath ? (
							<Link to="/">홈으로</Link>
						) : (
							<Link to="/admin">관리자 페이지</Link>
						)}
					</Button>
				)}
				<Button
					variant="outline"
					size="sm"
					className="rounded-full border-doxmeet text-doxmeet hover:text-doxmeet"
				>
					<a
						href="https://www.doxmeet.com"
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-2"
					>
						닥스밋 보러가기
					</a>
				</Button>
				<Button
					size="sm"
					onClick={logout}
					className="px-4 bg-gray-500 hover:bg-gray-600"
				>
					로그아웃
				</Button>
			</div>
		</header>
	);
};
